<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="critereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('listeContacts.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('listeContacts.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div
      class="column is-12 overflow-auto
      is-marginless hauteur-brief-filtre">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <query-client-tag-input
            v-model="critereRecherche.tiers"
            :label="$t('listeContacts.filtre.client')"
            :societeActiveId="societeActiveId">
          </query-client-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeContacts.filtre.archive')">
            <b-select v-model="critereRecherche.archive">
              <option :value="null">
              </option>
              <option :value="true"> {{ $t('listeContacts.filtre.yes') }}
              </option>
              <option :value="false"> {{ $t('listeContacts.filtre.no') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <query-tag-input
              :label="$t('listeContacts.filtre.marque')"
              v-model="marquesSelected"
              field="libelle"
              :query="(search) => func.getAllMarques(constantes.PARAMETRES_KEYS.marque, {
                  query:
                    {
                      auto: search,
                      actif: true,
                    },
                })">
            <template slot-scope="props">
              {{ props.option.libelle }}
            </template>
          </query-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeContacts.filtre.newsLetter')">
            <b-select v-model="critereRecherche.newsletter">
              <option :value="null">
              </option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()"
      >{{$t('listeContacts.filtre.actions.appliquer')}}</button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()"
      >{{$t('listeContacts.filtre.actions.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import genererCritereRecherche from '@/services/contact/genererCritereRechercheContact';
import queryClientTagInput from '@/components/general/tagInput/queryClientTagInput';
import { pGetAll as getAllMarques } from '@/api/parametre/index';
import queryTagInput from '@/components/general/tagInput/queryTagInput';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      critereRecherche: null,
      func: {
        getAllMarques,
      },
      constantes: {
        PARAMETRES_KEYS,
      },
      marquesSelected: [],
    };
  },
  components: {
    queryClientTagInput,
    queryTagInput,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    viderCritere() {
      this.critereRecherche = cloneDeep(genererCritereRecherche());
      this.marquesSelected = [];
    },
    appliquerCritere() {
      this.critereRecherche.marqueIds = this.marquesSelected.map(el => {
        return el.id;
      });
      this.$emit('input', this.critereRecherche);
      this.$emit('recherche');
    },
    initializeFiltre() {
      this.critereRecherche = cloneDeep(this.value);
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
